export enum KioskConfigurationTypeEnum {
  serviceTypeEnabled = 'Service Type Enabled',
  loyaltyEnabled = 'Loyalty Enabled',
  flagEnabled = 'Flag Enabled',
  autoLogoutEnabled = 'Auto Logout Enabled',
  inactivityTimeoutSeconds = 'Inactivity Timeout Seconds',
  heroImageLink = 'Hero Image Link',
  heroVideoLink = 'Hero Video Link'
}
